/**
 * YAML semilla de todo borrador nuevo. Mantiene la estructura acordada con el
 * backend (raiz "Template:", funciones inline en las expresiones {{...}} y
 * fill anidado {char, side}). El front no lo valida: la validacion es del
 * backend (POST /validate).
 */
export const buildBaseYaml = (): string => `Template:
  output:
    format: TXT # TXT | CSV | EXCEL
    extension: txt # txt | env | tef | csv | xlsx
    encoding: utf-8
    lineEnding: CRLF # LF | CRLF
    delimiter: null # CSV/TXT delimitado: "," | ";" | "\\t"
    fileName: '{{payroll.code}}_{{payroll.period.endDate}}.{{output.extension}}'

  records:
    - type: header # header | body | footer
      columns:
        - key: recordType
          length: 1
          value: 'H'
          align: left
          fill:
            char: ' '
            side: right
          truncate: right

        - key: payerAccount
          length: 22
          value: '{{digitsOnly(company.account.number)}}'
          align: right
          fill:
            char: '0'
            side: left

        - key: paymentDate
          length: 8
          value: '{{payroll.period.endDate}}'
          format: YYYYMMDD
          required: true

    - type: body
      sortBy:
        - path: transaction.sequence
          direction: asc
      columns:
        - key: beneficiaryAccount
          length: 22
          value: '{{digitsOnly(transaction.beneficiaryAccount.number)}}'
          fill:
            char: '0'
            side: left

        - key: accountType
          length: 2
          value: '{{transaction.beneficiaryAccount.type.code}}'
          fill:
            char: '0'
            side: left

        - key: amount
          length: 15
          value: '{{fixedAmount(transaction.amount, transaction.beneficiaryAccount.currency.decimals, false)}}'
          fill:
            char: '0'
            side: left

        - key: beneficiaryName
          length: 40
          value: '{{removeAccents(upper(transaction.beneficiary.fullName))}}'
          fill:
            char: ' '
            side: right

        - key: reference
          length: 30
          value: '{{payroll.name}}'
          fill:
            char: ' '
            side: right

    - type: footer
      columns:
        - key: recordType
          length: 1
          value: 'F'

        - key: totalTransactions
          length: 6
          value: '{{totals.transactions}}'
          fill:
            char: '0'
            side: left

        - key: totalAmount
          length: 15
          value: '{{fixedAmount(totals.amount, company.account.currency.decimals, false)}}'
          fill:
            char: '0'
            side: left
`
